var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9987 2.66634H4.66536V1.99967C4.66536 1.07967 3.9187 0.333008 2.9987 0.333008C2.0787 0.333008 1.33203 1.07967 1.33203 1.99967V2.66634H0.998698C0.632031 2.66634 0.332031 2.96634 0.332031 3.33301V6.66634C0.332031 7.03301 0.632031 7.33301 0.998698 7.33301H4.9987C5.36536 7.33301 5.66536 7.03301 5.66536 6.66634V3.33301C5.66536 2.96634 5.36536 2.66634 4.9987 2.66634ZM2.9987 5.66634C2.63203 5.66634 2.33203 5.36634 2.33203 4.99967C2.33203 4.63301 2.63203 4.33301 2.9987 4.33301C3.36536 4.33301 3.66536 4.63301 3.66536 4.99967C3.66536 5.36634 3.36536 5.66634 2.9987 5.66634ZM1.9987 2.66634V1.99967C1.9987 1.44634 2.44536 0.999674 2.9987 0.999674C3.55203 0.999674 3.9987 1.44634 3.9987 1.99967V2.66634H1.9987Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.d444c5f4.svg";
export { ForwardRef as ReactComponent };